import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationContainerComponent } from '../authorization-container/authorization-container.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { FilledButtonComponent } from '@custom-components/general/button/filled-button/filled-button.component';

@Component({
  selector: 'xemex-set-new-password-success-page',
  imports: [MatIcon, TranslateModule, AuthorizationContainerComponent, FilledButtonComponent],
  templateUrl: './set-new-password-success-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './set-new-password-success-page.component.scss',
})
export class SetNewPasswordSuccessPageComponent {
  private readonly router = inject(Router);

  backToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
